import React, {useCallback, useEffect, useRef, useState} from "react";
import {ChipInput} from "./ChipInput";


export type ToggleChipInputProps = {
    value?: boolean
    onChange?: (value: boolean) => any
    label?: React.ReactNode
    disabled?: boolean
}


export const ToggleChipInput = (props: ToggleChipInputProps) => {
    const {value: inValue, onChange, label, disabled} = props;
    const uncontrolled = typeof inValue == "undefined";
    const [value, setValue] = useState(uncontrolled ? false : inValue);
    const ref = useRef<HTMLDivElement>();


    useEffect(() => {
        setValue(inValue);
    }, [inValue]);

    const handleClick = useCallback(() => {
        ref?.current?.blur();
        if (uncontrolled) {
            setValue(!value);
        }
        onChange && onChange(!value);
    }, [value, uncontrolled, onChange]);

    return (
        <ChipInput
            ref={ref}
            selected={!!value}
            onClick={handleClick}
            disabled={disabled}
            label={label}
            color="additionalPrimary"
        />
    )
}